import { AxiosRequestConfig } from 'axios';
import { map } from 'lodash';
import { useCreateQuery, QueryOptions } from '../../CRUD';
import { axiosService } from '../../services/axiosService';
import { patientFormBaseModel } from './crud';

export type TUsePatientFormsMedicationSearchResponse = Array<{
  drugName: string;
  genericName: string;
  strength: string;
}>;

export type TUsePatientFormsMedicationSearchParams = {
  search: string;
  limit?: number;
};

const { keys } = patientFormBaseModel;

export const usePatientFormMedicationSearch = (
  params: TUsePatientFormsMedicationSearchParams,
  options?: QueryOptions<AxiosRequestConfig['params']>,
) => {
  async function queryFn() {
    const { search, limit = 100 } = params;

    const { data } = await axiosService.get(
      `${keys.basicUrlPath}/medicationsearch`,
      { params: { search, limit } },
    );
    const medications = map(data?.response, (medication) => ({
      drugName: medication.d,
      genericName: medication.a,
      strength: medication.s,
    }));

    return medications;
  }

  return useCreateQuery<
    TUsePatientFormsMedicationSearchResponse,
    TUsePatientFormsMedicationSearchParams
  >(['medicationsearch', params.search], queryFn, params, options);
};
